import SearchableCountrySelect from "../../../components/SearchableCountrySelect";
import { useRegister } from "../RegisterContext";
import { SPORTS } from "../data/sports";
import { LEVELS } from "../data/levels";
import { useEffect } from "react";
import { get } from "../../../http/api";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function AthleteForm() {
    const { handleChange, handleDetailsChange, formData, fieldErrors, details, sport, setSport, setDetails, leagues,
        countries, getCountryTranslation, teams, setFootballCountry, setLeagues, footballCountry, setTeams, PHONE_RULES, passwordStrength } = useRegister();

    const [loadingLeagues, setLoadingLeagues] = useState(false);
    const [loadingTeams, setLoadingTeams] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {

        if (!footballCountry) return;

        const fetchLeagues = async () => {

            setLoadingLeagues(true);

            setLeagues([]);
            setTeams([]);

            try {

                const res = await get(
                    `football/leagues?country=${encodeURIComponent(footballCountry)}`
                );

                setLeagues(
                    res.data || []
                );

            } catch {

                setLeagues([]);

            } finally {

                setLoadingLeagues(false);

            }
        };

        fetchLeagues();

    }, [footballCountry]);

    // useEffect(() => {
    //     if (!country) return;

    //     const fetchLeagues = async () => {
    //         setLoadingLeagues(true);
    //         setLeagues([]);
    //         setTeams([]);

    //         try {
    //             const res = await get(`football/leagues?country=${country}`);
    //             setLeagues(res.data || []);
    //         } catch (err) {
    //             setLeagues([]);
    //         } finally {
    //             setLoadingLeagues(false);
    //         }
    //     };

    //     fetchLeagues();
    // }, [country]);

    useEffect(() => {
        if (
            !details.league_id ||
            !details.season ||
            !isProfessional
        ) return;

        const fetchTeams = async () => {
            setLoadingTeams(true);
            setTeams([]);

            try {
                const res = await get(
                    `football/teams?league=${encodeURIComponent(details.league_id)}&season=${encodeURIComponent(details.season || "2024")}`
                );

                setTeams(res.data || []);
            } catch {
                setTeams([]);
            } finally {
                setLoadingTeams(false);
            }
        };

        fetchTeams();

    }, [
        details.league_id,
        details.season,
        details.level
    ]);

    const isAmateur = details.level === "Amateur";

    const isProfessional =
        details.level &&
        details.level !== "Amateur";


    return (
        <form className="register-form-grid">
            <>
                <div className="input-wrapper">
                    <input
                        className={`register-inputs ${fieldErrors.username ? "input-error" : ""}`}
                        name="username"
                        value={formData.username}
                        placeholder={
                            t("athleteForm.username")
                        }
                        onChange={handleChange}
                        required
                    />

                    {fieldErrors.username && (
                        <div className="error-message">
                            <span className="error-icon">✖</span>
                            {fieldErrors.username}
                        </div>
                    )}
                </div>
                <input
                    className='register-inputs'
                    name='lastname'
                    value={formData.lastname}
                    placeholder={
                        t("athleteForm.lastname")
                    }
                    onChange={handleChange}
                    required
                />
                <input
                    className='register-inputs'
                    name="firstname"
                    value={formData.firstname}
                    placeholder={
                        t("athleteForm.firstname")
                    }
                    onChange={handleChange}
                    required
                />
                <div className="input-wrapper">
                    <input
                        className={`register-inputs ${fieldErrors.email ? "input-error" : ""}`}
                        name="email"
                        autoComplete="new-email"
                        type="email"
                        value={formData.email}
                        placeholder={
                            t("athleteForm.email")
                        }
                        onChange={handleChange}
                        required
                    />

                    {fieldErrors.email && (
                        <div className="error-message">
                            <span className="error-icon">✖</span>
                            {fieldErrors.email}
                        </div>
                    )}
                </div>
                <div className="input-wrapper">
                    <label className="register-date-label" htmlFor="athlete-birthdate">
                        {t("athleteForm.birthdate")}
                    </label>
                    <input
                        id="athlete-birthdate"
                        className={`register-inputs ${fieldErrors.password
                            ? "input-error"
                            : passwordStrength.valid
                                ? "input-success"
                                : ""
                            }`}
                        type="password"
                        name="password"
                        autoComplete="new-password"
                        placeholder={
                            t("athleteForm.password")
                        }
                        value={formData.password || ""}
                        onChange={handleChange}
                    />

                    {formData.password && (
                        <>
                            <div className="password-strength-bar">
                                <span
                                    style={{
                                        width: `${passwordStrength.score * 20}%`,
                                    }}
                                    className={
                                        passwordStrength.score <= 2
                                            ? "weak"
                                            : passwordStrength.score <= 4
                                                ? "medium"
                                                : "strong"
                                    }
                                />
                            </div>

                            <small className="password-message">
                                {passwordStrength.message}
                            </small>
                        </>
                    )}
                </div>
                <div className="input-wrapper">
                    <input
                        className={`register-inputs ${fieldErrors.birthdate ? "input-error" : ""}`}
                        type="date"
                        name="birthdate"
                        value={formData.birthdate || ""}
                        onChange={handleChange}
                        required
                    />

                    {fieldErrors.birthdate && (
                        <div className="error-message">
                            <span className="error-icon">✖</span>
                            {fieldErrors.birthdate}
                        </div>
                    )}
                </div>
                <input
                    className='register-inputs'
                    name='address'
                    value={formData.address}
                    placeholder={
                        t("athleteForm.address")
                    }
                    onChange={handleChange}
                />
                <input
                    className='register-inputs'
                    name='postal_code'
                    value={formData.postal_code}
                    placeholder={
                        t("athleteForm.postalCode")
                    }
                    onChange={handleChange}
                />
                <SearchableCountrySelect
                    required
                    className="register-select"
                    name="country"
                    value={formData.country || ""}
                    onChange={(e) => {
                        const value = e.target.value;

                        handleChange(e);
                        // setCountry(value);

                        setDetails((prev) => ({
                            ...prev,
                            league_id: null,
                            league_name: null,
                            season: null,
                            team_id: null,
                            team_name: null,
                            amateur_club: null,
                        }));

                        // setLeagues([]);
                        // setTeams([]);
                    }}
                >
                    <option value="">{t("athleteForm.country")}</option>

                    {countries.map((country) => (
                        <option
                            key={country.code}
                            value={country.name}
                        >
                            {country.flag} {country.name}
                        </option>
                    ))}

                    {/* {countries.map((c) => (
                        <option key={c} value={c}>
                            {
                                getCountryTranslation(
                                    c
                                )
                            }
                        </option>
                    ))} */}
                </SearchableCountrySelect>

                <select
                    required
                    className="register-select"
                    name="language"
                    value={formData.language}
                    onChange={handleChange}
                >

                    <option value="">
                        {t("athleteForm.language")}
                    </option>

                    <option value="fr">
                        🇫🇷 Français
                    </option>

                    <option value="en">
                        🇬🇧 English
                    </option>

                    <option value="ar">
                        🇲🇦 العربية
                    </option>

                    <option value="es">
                        🇪🇸 Español
                    </option>
                    <option value="pt">🇵🇹 Português</option>
                    <option value="zh">🇨🇳 中文（简体）</option>
                    <option value="de">🇩🇪 Deutsch</option>
                    <option value="ru">🇷🇺 Русский</option>
                    <option value="it">🇮🇹 Italiano</option>
                    <option value="sr">🇷🇸 Srpski</option>

                </select>

                <div className="input-wrapper">
                    <input
                        required
                        className={`register-inputs ${fieldErrors.phone ? "input-error" : ""
                            }`}
                        name="phone"
                        value={formData.phone || ""}
                        placeholder={
                            PHONE_RULES[formData.country]?.placeholder ||
                            t("athleteForm.phone")
                        }
                        onChange={handleChange}
                    />

                    {fieldErrors.phone && (
                        <div className="error-message">
                            <span className="error-icon">✖</span>
                            {fieldErrors.phone}
                        </div>
                    )}
                </div>

            </>

            <select
                className='register-select'
                name="sport"
                value={details.sport || ""}
                required
                onChange={(e) => {
                    setSport(e.target.value);
                    handleDetailsChange(e);
                }}
            >
                <option value="">{t("athleteForm.sport")}</option>

                <option value="Football">
                    {t("athleteForm.football")}
                </option>

                <option disabled style={{ color: "#999" }}>
                    {t("athleteForm.basketSoon")}
                </option>

                <option disabled style={{ color: "#999" }}>
                    {t("athleteForm.handballSoon")}
                </option>
            </select>

            {sport && (
                <select required className='register-select' name='position' value={details.position || ""} onChange={handleDetailsChange}>
                    <option value="">{t("athleteForm.position")}</option>
                    {SPORTS[sport].map((p) => (
                        <option key={p}>{p}</option>
                    ))}
                </select>
            )}

            <select required className='register-select' name='level' value={details.level || ""} onChange={handleDetailsChange}>
                <option value="">{t("athleteForm.level")}</option>
                {LEVELS.map((l) => (
                    <option key={l.value} value={l.value}>{t(l.label)}</option>
                ))}
            </select>

            <input
                required
                className="register-inputs"
                type="number"
                name="height"
                value={details.height || ""}
                placeholder={
                    t("athleteForm.height")
                }
                min="100"
                max="250"
                onChange={handleDetailsChange}
            />

            <select
                className="register-select"
                name="strong_foot"
                value={details.strong_foot || ""}
                onChange={handleDetailsChange}
                required
            >
                <option value="">{t("athleteForm.strongFoot")}</option>
                <option value="Right">{t("athleteForm.right")}</option>
                <option value="Left">{t("athleteForm.left")}</option>
                <option value="Both">{t("athleteForm.both")}</option>
            </select>
            {/* Amateur */}
            {isAmateur && (
                <input
                    className="register-inputs"
                    name="amateur_club"
                    value={details.amateur_club || ""}
                    placeholder={
                        t("athleteForm.clubName")
                    }
                    onChange={handleDetailsChange}
                    required
                />
            )}


            {isProfessional && (

                <>
                    <SearchableCountrySelect
                        required
                        className="register-select"
                        value={footballCountry}
                        onChange={(e) => {

                            setFootballCountry(
                                e.target.value
                            );

                            setDetails(prev => ({
                                ...prev,

                                football_country:
                                    e.target.value,

                                league_id: null,
                                league_name: null,

                                season: null,

                                team_id: null,
                                team_name: null,

                                amateur_club: null
                            }));

                            setLeagues([]);
                            setTeams([]);
                        }}
                    >

                        <option value="">
                            {t("athleteForm.footballCountry")}
                        </option>

                        {countries.map((c) => (

                            <option
                                key={c.code}
                                value={c.name}
                            >
                                {c.flag} {c.name}
                            </option>

                        ))}

                    </SearchableCountrySelect>

                </>
            )}

            {/* Semi-pro / Pro / Elite */}
            {isProfessional && (
                <>
                    {loadingLeagues && (
                        <div className="loading-hint">
                            ⏳ Chargement des ligues...
                        </div>
                    )}

                    {leagues.length > 0 && (
                        <select
                            required
                            className="register-select"
                            onChange={(e) => {
                                const option = e.target.selectedOptions[0];

                                setDetails((prev) => ({
                                    ...prev,
                                    league_id: option.value,
                                    league_name: option.text,
                                    season: option.dataset.season,
                                    team_id: null,
                                    team_name: null,
                                }));
                            }}
                        >
                            <option value="">Ligue</option>

                            {leagues.map((l) => (
                                <option
                                    key={l.id}
                                    value={l.id}
                                    data-season={l.season}
                                >
                                    {l.name} ({l.season})
                                </option>
                            ))}
                        </select>
                    )}

                    {loadingTeams && (
                        <div className="loading-hint">
                            ⏳ Chargement des équipes...
                        </div>
                    )}

                    {teams.length > 0 && (
                        <select
                            required
                            className="register-select"
                            onChange={(e) => {
                                const option = e.target.selectedOptions[0];

                                setDetails((prev) => ({
                                    ...prev,
                                    team_id: option.value,
                                    team_name: option.text,
                                }));
                            }}
                        >
                            <option value="">Équipe actuelle</option>

                            {teams.map((t) => (
                                <option key={t.id} value={t.id}>
                                    {t.name}
                                </option>
                            ))}
                        </select>
                    )}
                </>
            )}

            {/* <select
                className="register-select"
                name="country"
                value={formData.country || ""}
                onChange={(e) => {
                    const value = e.target.value;

                    // pour table profiles
                    handleChange(e);

                    // pour fetch ligues
                    setCountry(value);

                    // reset dépendances football
                    setDetails(prev => ({
                        ...prev,
                        league_id: null,
                        league_name: null,
                        season: null,
                        team_id: null,
                        team_name: null,
                    }));

                    setLeagues([]);
                    setTeams([]);
                }}
            >
                <option value="">Pays</option>

                {countries.map((c) => (
                    <option key={c} value={c}>
                        {c}
                    </option>
                ))}
            </select>


            {loadingLeagues && (
                <div className="loading-hint">
                    ⏳ Chargement des ligues...
                </div>
            )}

            {leagues.length > 0 && (
                <select
                    className="register-select"
                    onChange={(e) => {
                        const option = e.target.selectedOptions[0];

                        setDetails(prev => ({
                            ...prev,
                            league_id: option.value,
                            league_name: option.text,
                            season: option.dataset.season,
                            team_id: null,
                            team_name: null,
                        }));
                    }}
                >
                    <option value="">Ligue</option>
                    {leagues.map(l => (
                        <option
                            key={l.id}
                            value={l.id}
                            data-season={l.season}
                        >
                            {l.name} ({l.season})
                        </option>
                    ))}
                </select>
            )}

            {loadingTeams && (
                <div className="loading-hint">
                    ⏳ Chargement des équipes...
                </div>
            )}

            {teams.length > 0 && (
                <select
                    className="register-select"
                    onChange={(e) => {
                        const option = e.target.selectedOptions[0];

                        handleDetailsChange({
                            target: { name: "team_id", value: option.value }
                        });

                        setDetails(prev => ({
                            ...prev,
                            team_name: option.text
                        }));
                    }
                        // handleDetailsChange({ target: { name: "team_id", value: e.target.value } })
                    }
                >
                    <option value="">Équipe actuelle</option>
                    {teams.map((t) => (
                        <option key={t.id} value={t.id}>{t.name}</option>
                    ))}
                </select>
            )} */}

            {/* <div className="input-wrapper">
                <label className="pdf-upload-label">
                    Carte nationale (PDF)

                    <input
                        type="file"
                        name="national_id_pdf"
                        accept=".pdf,application/pdf"
                        onChange={handleChange}
                        hidden
                    />
                </label>

                {formData.national_id_pdf && (
                    <div className="pdf-selected">
                        📄 {formData.national_id_pdf.name}
                    </div>
                )}

                {fieldErrors.national_id_pdf && (
                    <div className="error-message">
                        <span className="error-icon">✖</span>
                        {fieldErrors.national_id_pdf}
                    </div>
                )}
            </div> */}
        </form>
    );
}
